import React, { useEffect, useState } from "react";
import "./App.css";
import "./index.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import "./components/common_components/common_css/Common_Css.css";
import "./components/common_components/common_css/Common_Form_Css.css";
import "./components/common_components/common_css/Slider.css";
import Shop from "./components/shop/Shop";
import Blog from "./components/blog/Blog";
import Blog_inner from "./components/blog/blog_inner/Blog_inner";
import Product_Listing_Page from "./components/product_listing/Product_Listing_Page";
import WishList from "./components/wishlist/WishList";
import Product_Description from "./components/product_description/Product_Description";
import Cart from "./components/cart/Cart";
import SavedAddress from "./components/saved_address/SavedAddress";
import AddNewAddress from "./components/add_new_address/AddNewAddress";
import Checkout from "./components/checkout/Checkout";
import My_Orders from "./components/my_orders/My_Orders";
import My_Profile from "./components/my_profile/My_Profile";
import Order_details from "./components/my_orders/order_details/Order_details";
import Delivered_order from "./components/my_orders/delivered_order/Delivered_order";
import Cancel_order_details from "./components/my_orders/cancel_order_details/Cancel_order_details";
import My_Wallet from "./components/my_profile/my_wallet/My_Wallet";
import Change_Password from "./components/change_password/Change_Password";
import Cancel_order from "./components/my_orders/cancel_order/Cancel_order";
import TrackOrder from "./components/track_order/TrackOrder";
import Return_order from "./components/my_orders/return_order/Return_order";
import About_us from "./components/about-us/About_us";
import Career from "./components/career/Career";
import Career_Inner from "./components/career_inner/Career_Inner";
import Contact_Us from "./components/contact_us/Contact_Us";
import Faq from "./components/faq/Faq";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import Privacy_Policy from "./components/privacy_policy/Privacy_Policy";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import All_Products_Page from "./components/shop/all_products_page/All_Products_Page";
import { checkTokenValidity } from "./features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrderAddress } from "./features/order/orderSlice";

import Return_order_details from "./components/my_orders/return_order_details/Return_order_details";
import { getLocationFromSession } from "./features/location/locationSlice";

import Cookies from "js-cookie";
import ShopSingle from "./components/shop/ShopSingle";
import EditNewAddress from "./components/add_new_address/EditNewAddress";
import Product_Listing_Page_SubCategory from "./components/product_listing/Product_Listing_Page_SubCategory";
import Order_Placed_Page from "./components/order_placed_page/Order_Placed_Page";
import Product_Listing_Page_ChildCategory from "./components/product_listing/Product_Listing_Page_SubCategory";
import All_Product from "./components/product_listing/All_Product";
function App() {
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const checkToken = () => {
    dispatch(checkTokenValidity());
  };
  useEffect(() => {
    checkToken();
  }, []);

  const allAddress = useSelector((state) => state.order.allOrdersAddress);

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    if (user?.id) {
      dispatch(getAllOrderAddress());
    }
  }, []);

  const [addressId, setAddressId] = useState(null);

  const [addressBillingId, setAddressBillingId] = useState(null);
  // useEffect(() => {
  //   if (allAddress?.data?.length > 0) {
  //     setAddressId(allAddress.data[0].id);
  //   }
  // }, [allAddress]);

  const [orderAddress, setOrderAddress] = useState({});
  const [orderBillingAddress, setOrderBillingAddress] = useState({});
  const [deliveryNote, setDeliveryNote] = useState();

  const current_location = useSelector(
    (state) => state.location.current_location
  );
  // useEffect(() => {
  //   dispatch(getAllCountriesByName(current_location?.country));
  //   dispatch(getCityByName(current_location?.city));
  // }, [current_location]);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getLocationFromSession());
  }, [dispatch]);

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:id" element={<ShopSingle />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-inner/:id" element={<Blog_inner />} />
        <Route path="/product-listing/:id" element={<Product_Listing_Page />} />

        <Route
          path="/product-listing-child-category/:id"
          element={<Product_Listing_Page_ChildCategory />}
        />
        <Route
          path="/product-listing-sub-category/:id"
          element={<Product_Listing_Page_SubCategory />}
        />
        <Route path="/all-product" element={<All_Product />} />
        <Route path="/wishlist" element={<WishList />} />
        <Route
          path="/product-description/:id"
          element={<Product_Description />}
        />

        <Route
          path="/cart"
          element={
            <Cart
              deliveryNote={deliveryNote}
              setDeliveryNote={setDeliveryNote}
              isSignIn={isSignIn}
              orderAddress={orderAddress}
              etOrderAddress={setOrderAddress}
            />
          }
        />

        <Route
          path="/saved-address"
          element={
            <SavedAddress
              addressId={addressId}
              setAddressId={setAddressId}
              orderAddress={orderAddress}
              setOrderAddress={setOrderAddress}
              setOrderBillingAddress={setOrderBillingAddress}
              orderBillingAddress={orderBillingAddress}
              addressBillingId={addressBillingId}
              setAddressBillingId={setAddressBillingId}
            />
          }
        />

        <Route
          path="/add-new-address"
          element={
            <AddNewAddress addressId={addressId} setAddressId={setAddressId} />
          }
        />

        <Route
          path="/edit-new-address/:id"
          element={
            <EditNewAddress addressId={addressId} setAddressId={setAddressId} />
          }
        />
        <Route
          path="/checkout"
          element={
            <Checkout
              deliveryNote={deliveryNote}
              setDeliveryNote={setDeliveryNote}
              addressId={addressId}
              addressBillingId={addressBillingId}
              setAddressId={setAddressId}
              orderAddress={orderAddress}
              setOrderAddress={setOrderAddress}
              orderBillingAddress={orderBillingAddress}
              isSignIn={isSignIn}
            />
          }
        />
        <Route path="/my-orders" element={<My_Orders />} />
        <Route path="/my-profile" element={<My_Profile />} />
        <Route path="/order-details/:id" element={<Order_details />} />
        <Route path="/delivered-order/:id" element={<Delivered_order />} />
        <Route
          path="/cancel-order-details/:id"
          element={<Cancel_order_details />}
        />
        <Route path="/cancel-order/:id" element={<Cancel_order />} />
        <Route path="/return-order/:id" element={<Return_order />} />
        <Route
          path="/return-order-details/:id"
          element={<Return_order_details />}
        />
        <Route path="/my-wallet" element={<My_Wallet />} />
        <Route path="/change-password" element={<Change_Password />} />
        <Route path="/order-track/:id" element={<TrackOrder />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/career" element={<Career />} />
        <Route path="/career-inner/:id" element={<Career_Inner />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/all-products" element={<All_Products_Page />} />
        <Route path="/order-placed" element={<Order_Placed_Page />} />

        <Route path="/order-failed" element={<Order_Placed_Page />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
